import { createAction } from "redux-actions"

import { RESET_STATUS } from "../constants/ActionTypes"

export const resetStatus = createAction(RESET_STATUS)
